module.exports = __webpack_public_path__ + "static/winter_eladrin-ce7ef84f1d0ac39f110aa640508db5d3.png";